import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import Svg, { Path } from "react-native-svg";
import { TouchableOpacity, View } from "react-native";
import { fp, spH, spV, wp } from "utils/normalise";

import Accordion from "components/Accordion";
import { SORT_OPTIONS } from "utils/Constants";
import VText from "components/VText";
import { router } from "expo-router";
import { useDispatch } from "react-redux";
import { useState } from "react";

const SortingComp = ({ selected = SORT_OPTIONS[0], setSelected = () => {} }) => {
    const [isOpen, setIsOpen] = useState(false);

    const rotate = useSharedValue(0);
    const dispatch = useDispatch();

    const animatedStyles = useAnimatedStyle(() => ({
        transform: [{ rotateZ: `${rotate.value}deg` }],
    }));

    return (
        <View
            style={{
                zIndex: 100,
                elevation: 100,
                backgroundColor: "white",
            }}
        >
            <TouchableOpacity
                style={{
                    borderWidth: 1,
                    borderColor: "#212427",
                    paddingVertical: spV(8),
                    paddingHorizontal: spH(20),
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
                activeOpacity={0.8}
                onPress={() => {
                    setIsOpen((prev) => {
                        if (prev) {
                            rotate.value = withTiming(0);
                            return false;
                        } else {
                            rotate.value = withTiming(180);
                            return true;
                        }
                    });
                }}
            >
                <VText
                    style={{
                        paddingRight: spH(16),
                        fontSize: fp(16),
                        lineHeight: fp(24),
                        fontWeight: "350",
                    }}
                    text={selected.title}
                />
                <Animated.View style={animatedStyles}>
                    <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <Path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M4 8.29936L5.29936 7L12 13.7006L18.7006 7L20 8.29936L12 16.2994L4 8.29936Z"
                            fill="#212427"
                        />
                    </Svg>
                </Animated.View>
            </TouchableOpacity>
            <Accordion
                style={{
                    position: "absolute",
                    top: 65,
                    zIndex: 100,
                    elevation: 100,
                    backgroundColor: "blue",
                    shadowColor: "rgba(0, 0, 0, 0.25)",
                    shadowOffset: { width: 0, height: 2 },
                    shadowOpacity: 0.4,
                    shadowRadius: 4,
                }}
                viewKey="qwerty"
                isExpanded={isOpen}
            >
                <View
                    style={{
                        backgroundColor: "white",
                        paddingHorizontal: spH(20),
                        paddingVertical: spV(16),
                    }}
                >
                    {SORT_OPTIONS.map((o, idx) => (
                        <TouchableOpacity
                            key={idx}
                            activeOpacity={0.8}
                            onPress={() => {
                                setSelected(o);
                                setIsOpen(false);
                                rotate.value = withTiming(0);
                                router.setParams({ sortBy: o?.type, page: 1 });
                            }}
                        >
                            <VText
                                style={{
                                    paddingTop: idx == 0 ? 0 : spV(12),
                                    paddingBottom: idx == SORT_OPTIONS.length - 1 ? 0 : spV(12),
                                    borderBottomWidth: idx == SORT_OPTIONS.length - 1 ? 0 : 1,
                                    borderColor: "rgba(33, 36, 39, 0.3)",
                                    color: "rgb(33, 36, 39)",
                                    opacity: selected?.id == o?.id ? 1 : 0.6,
                                    fontSize: fp(16),
                                    lineHeight: fp(24),
                                    fontWeight: "350",
                                }}
                                text={o.title}
                            />
                        </TouchableOpacity>
                    ))}
                </View>
            </Accordion>
        </View>
    );
};

export default SortingComp;
